import { useState, useEffect, useCallback } from 'react';
import { generateAndUploadThumbnailUrl, getMediaType, getUrlExtension, isValidMimeType } from '../../utils/custom-utils';
import { guessContentType, proxiedUrlFor } from '../../utils/media-url-utils';
import configs from '../../utils/configs';
import { getCookieToken } from '../../utils/get-auth-user';
import { useUploadForm } from '../contexts/UploadFormContext';

const possibleLinkExtensions = ["gif", "png", "jpg", "jpeg", "webp", "mp4", "mp3", "pdf", "glb"];

const folder = `assets360/${configs.APP_NAME}/my-media`;

const useUrlUpload = () => {
    const token = getCookieToken();
    const {onErrorUrlUploadChange, errorUploadUrl} = useUploadForm();
    const [mimeType, setMimeType] = useState(null);
    const urlUpload = useCallback(async(url) => {
        if(!url) {
          return;
        }

        const mimeType = await fetchMimeType(url);
        if(!mimeType) {
            return null;
        }

        const name = url.split("/").pop();
        const myMediaUrl = `${configs["CUSTOM_API_URL"]}/assets360`;

        try {
          const thumbnail = mimeType.includes("image") 
              || mimeType.includes("video") 
              || mimeType.includes("pdf") 
              || mimeType.includes("model")
              || mimeType == "application/octet-stream"
            ? await generateAndUploadThumbnailUrl({ url, token, folder, name, mimeType })
            : null;

            const entry = {
              name: name,
              title: name,
              path: url,
              type: getMediaType(url),
              asset_type: "my-media",
              thumbnail: thumbnail,
              public_thumbnail: thumbnail,
            };

            if(thumbnail) {
              entry.thumbnail = thumbnail;
            }

            // send to my media
            const myMediaResponse = await fetch(myMediaUrl, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                accept: "application/json",
                authorization: `Bearer ${token}`
              },
              body: JSON.stringify(entry)
            });

            const myMediaJson = await myMediaResponse.json();
            if(myMediaJson?.error) {
                onErrorUrlUploadChange("Error uploading URL");
                return null;
            }

            return myMediaJson?.data;
        } catch(error) {
            console.error('Error uploading URL:', error);
            onErrorUrlUploadChange('Error uploading URL');
            return null;
        }


    }, [])


    async function fetchMimeType(url) {

      try {
        // Fetch only the headers of the URL
        const proxiedUrl = proxiedUrlFor(url);

        const response = await fetch(proxiedUrl, { method: 'HEAD' });
        const contentType = response.headers.get('Content-Type');
        // Display the MIME type or a fallback message
        // setMimeType(contentType || 'Unknown MIME type');
        if(!contentType) {
            onErrorUrlUploadChange('Unknown MIME type');
        }

        if(isValidMimeType(contentType)) {
          return contentType;
        }
        onErrorUrlUploadChange('File type is not valid');
        
        return null;
      } catch (error) {
        console.error('Error fetching MIME type:', error);
        onErrorUrlUploadChange('Error fetching MIME type');
        return null;
      }
    }

  return {
    urlUpload,
    errorUpload: errorUploadUrl,
    onErrorUrlUploadChange
  };
};

export default useUrlUpload;